import { courseLink } from './course-link';

export function resolveNotificationLink(
  resourceType: string | null,
  resourceId: number | null,
): string | null {
  if (!resourceType) return null;

  switch (resourceType) {
    case 'competency_evidence':
      // Toda notificación de evidencia de competencia vive en /competency: el
      // aprobador ve ahí la sección de Revisión de evidencias (se auto-oculta si no
      // hay pendientes) y el colaborador ve ahí la carga de su certificado. NO usar
      // /instructor/evidence-review (eso es evidencia de LECCIÓN y está gateado a
      // instructor/admin — un supervisor aprobador sería rebotado a Home).
      return '/competency';
    case 'course':
      // Course-level notification: the portal has no course-keyed page, so route
      // through the by-course resolver, which redirects to the user's own
      // enrollment for that course. Also handles legacy notifications that stored
      // a course id under resource_type 'course'.
      return resourceId ? courseLink(resourceId) : '/courses';
    case 'document':
      // Deep-link to the specific assigned reading so it doesn't get lost among
      // the others (I7). Falls back to the list when no id is present.
      return resourceId ? `/documents/readings?highlight=${resourceId}` : '/documents/readings';
    case 'change_request':
      return '/supervisor/changes';
    case 'assessment':
      return resourceId ? `/competency/assessments/${resourceId}` : '/competency';
    case 'competency_declaration':
      return '/competency';
    case 'corrective_action':
      return resourceId ? `/competency/corrective-actions/${resourceId}` : '/competency';
    case 'enrollment':
      // The portal course detail route is enrollment-keyed (/courses/:enrollmentId).
      return resourceId ? `/courses/${resourceId}` : '/courses';
    case 'quiz':
      return resourceId ? `/quiz/${resourceId}` : '/courses';
    default:
      return null;
  }
}
